import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Tooltip,
  Typography,
  DialogActions,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RectangleOutlinedIcon from '@mui/icons-material/RectangleOutlined';
import CircleOutlinedIcon from '@mui/icons-material/RadioButtonUnchecked';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import TimelineIcon from '@mui/icons-material/Timeline';
import PentagonOutlinedIcon from '@mui/icons-material/PentagonOutlined';
import ChangeHistoryOutlinedIcon from '@mui/icons-material/ChangeHistoryOutlined';

const ShapeSelector = ({ open, onClose, onSelect }) => {
  const shapes = [
    { id: 'rectangle', name: 'Rectangle', icon: RectangleOutlinedIcon },
    { id: 'circle', name: 'Circle', icon: CircleOutlinedIcon },
    { id: 'line', name: 'Line', icon: HorizontalRuleIcon },
    { id: 'path', name: 'Draw Path', icon: TimelineIcon },
    { id: 'polygon', name: 'Polygon', icon: PentagonOutlinedIcon },
    { id: 'triangle', name: 'Triangle', icon: ChangeHistoryOutlinedIcon },
  ];

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Select Shape
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, p: 2 }}>
          {shapes.map((shape) => (
            <Tooltip key={shape.id} title={shape.name}>
              <Box
                onClick={() => {
                  onSelect(shape.id);
                  onClose();
                }}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                  p: 2,
                  border: '1px solid rgba(0,0,0,0.12)',
                  borderRadius: 1,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: 'rgba(238, 75, 15, 0.08)',
                    borderColor: 'var(--orange)'
                  }
                }}
              >
                <shape.icon sx={{ fontSize: 32, color: 'rgba(0,0,0,0.87)' }} />
                <Typography variant="caption" sx={{ color: 'rgba(0,0,0,0.6)' }}>
                  {shape.name}
                </Typography>
              </Box>
            </Tooltip>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShapeSelector; 